import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addUserGroups,
  deleteUserGroups,
  getAllUserGroups,
  updateUserGroups,
} from "controller/api";

import {
  ApiErrorType,
  GetAllUserGroupsInput,
  GetCustomerVendorsInput,
  GetQueryProps,
  UpdateUserGroup,
} from "shared";
import { sentryLogger } from "utilz";

export const useGetAllUserGroups = ({
  perPageCount,
  pageNumber,
  sortColumn,
  sortDirection,
  filter,
  searchQuery,
  customerId,
}: GetAllUserGroupsInput) => {
  return useQuery({
    queryKey: [
      "user_group",
      customerId,
      perPageCount,
      pageNumber,
      sortColumn,
      sortDirection,
      filter,
      searchQuery,
    ],
    queryFn: () =>
      getAllUserGroups({
        perPageCount,
        pageNumber,
        sortColumn,
        sortDirection,
        filter,
        searchQuery,
        customerId,
      }),
    enabled: customerId ? true : false,
    onSuccess: (data) => {},
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useAddCustomerUserGroup = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ customerIdParams, data }: { customerIdParams: any; data: any }) =>
      addUserGroups({ customerIdParams, data }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["user_group"]);
      },
      onError(error: ApiErrorType, variables, context) {
        sentryLogger({
          error: error,
          workflow: "customer",
          level: "error",
          functionName: "addUserGroups",
        });
      },
    }
  );
};

export const useUpdateCustomerUserGroup = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ groupId, customerId, data }: UpdateUserGroup) =>
      updateUserGroups({ groupId, customerId, data }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["user_group"]);
      },
      onError(error: ApiErrorType, variables, context) {
        sentryLogger({
          error: error,
          workflow: "customer",
          level: "error",
          functionName: "updateUserGroups",
        });
      },
    }
  );
};

export const useDeleteCustomerUserGroup = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({
      customerIdParams,
      groupIds,
    }: {
      customerIdParams: any;
      groupIds: any;
    }) => deleteUserGroups({ customerIdParams, groupIds }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["user_group"]);
      },
      onError(error: ApiErrorType, variables, context) {
        sentryLogger({
          error: error,
          workflow: "customer",
          level: "error",
          functionName: "deleteUserGroups",
        });
      },
    }
  );
};

// export const useAddCustomerVendor = () => {
//   const queryClient = useQueryClient();
//   return useMutation(
//     ({ customerIdParams, data }: any) =>
//       addCustomerVendor({ customerIdParams, data }),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries(["vendors"]);
//       },
//     }
//   );
// };

// export const useUpdateCustomerVendor = () => {
//   const queryClient = useQueryClient();
//   return useMutation(
//     ({ vendorId, data }: any) => updateCustomerVendor({ vendorId, data }),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries(["vendors"]);
//       },
//     }
//   );
// };

// export const useDeleteCustomerVendor = () => {
//   const queryClient = useQueryClient();
//   return useMutation(
//     ({
//       customerIdParams,
//       vendorIds,
//     }: {
//       customerIdParams: string;
//       vendorIds: any;
//     }) => deleteCustomerVendors({ customerIdParams, vendorIds }),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries(["vendors"]);
//       },
//     }
//   );
// };
